{
  "version": 1,
  "asset_id": "56513197-0728-41fd-bd42-178e37bbdae3",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/56513197-0728-41fd-bd42-178e37bbdae3/offer-overlay-sm.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/56513197-0728-41fd-bd42-178e37bbdae3/offer-overlay-sm.webp",
  "original_filename": "offer-overlay-sm.webp",
  "size": 51172,
  "content_type": "image/webp",
  "created_at": "2026-07-23T11:52:21Z"
}
